import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import useApi from '../../api/useApi';
import { roles } from '../../Constants';
import DeviceAssetInformation from '../../components/DeviceAssetInformation';
import '../../scrollbar.css';

function ProjectDetail({ projectId, handleClose }) {
  // const location = useLocation();
  const [projectDetail, setProjectDetail] = useState([]);
  const [{ isLoading, isError, data }, getData] = useApi();
  const [onClose, setOnClose] = useState(false);
  const [state, deleteDevice] = useApi();
  const [userdata, deleteUser] = useApi();
  const [openCreate, setOpenCreate] = useState(false);
  const [state2, setAssignProject] = useApi();
  const [selectedProject, setSelectedProject] = useState({ id: '', name: '' });
  const [editProject, setEditProject] = useState(false);
  const [bulkDevice, setBulkDevice] = useState([]);
  const [selectedTab, setSelectedTab] = useState('User');
  const [formData, setFormData] = useState({ role: '', isActive: '', userId: '' });
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = user && JSON.parse(sessionStorage.user).organization.id;

  useEffect(() => {
    getData(`/project/${projectId}`, 'GET');
  }, []);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setProjectDetail(data.project);
    }
    if (isError) {
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setOnClose(false);
      setBulkDevice([]);
      getData(`/project/${projectId}`, 'GET');
      // refreshList();
    }
    // if (state.isError) {
    //   setType('error');
    //   setMessage(state.data);
    //   setNotification(!notification);
    // }
  }, [state]);

  const getRole = (roleCode) => {
    const x = roles.filter((role) => role.id == roleCode);
    return x[0].value;
  };

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    return moment(_date).fromNow();
  };

  const handleDelete = () => {
    if (selectedTab === 'User') {
      deleteUser(`/project/${selectedProject.id}/users`, 'DELETE', { users: [formData.userId] });
    } else {
      deleteDevice(`/devices/assets`, 'DELETE', { device: bulkDevice });
    }
  };

  useEffect(() => {
    if (!userdata.isLoading && !userdata.isError && userdata.data) {
      setOnClose(false);
      setBulkDevice([]);
      getData(`/project/${projectId}`, 'GET');
      // refreshList();
    }
    if (userdata.data === '') {
      setOnClose(false);
      setBulkDevice([]);
      getData(`/project/${projectId}`, 'GET');
    }
  }, [userdata]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setAssignProject(`/project/${selectedProject.id}/users`, 'PATCH', formData);
  };

  useEffect(() => {
    if (!state2.isLoading && !state2.isError && state2.data) {
      // notification('success', 'User added to project successfully');
      // refreshList();
      getData(`/project/${projectId}`, 'GET');
      setEditProject(false);
    }
    if (state2.isError) {
      setEditProject(false);
    }
  }, [state2]);

  const toggleOpenCreate = () => {
    setOpenCreate((prev) => !prev);
  };

  return (
    <div className="w-full">
      {onClose && (
        <div
          className="flex justify-center items-center h-full w-full fixed top-0 left-0 devices_back"
          // style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-3/12 px-2 text-sm block m-auto rounded-2xl relative mobile_toggle">
            <span className="block font-bold border-b p-4 text-textBlue1">
              {selectedTab === 'User' ? 'Delete User' : 'Delete Device'}
            </span>
            <img
              src="assets/img/Close.svg"
              className="absolute top-4 right-3 h-3 cursor-pointer"
              alt=""
              onClick={() => setOnClose(false)}
            />
            <span className="block text-center text-sm mt-8 mb-8" style={{ color: '#9B9B9B' }}>
              {selectedTab === 'User'
                ? ` Do you want to delete ${selectedProject.name}?`
                : ` Do you want to deprovision ${bulkDevice[0]}?`}
            </span>
            <div className="mb-6 font-bold flex items-center justify-center">
              {/* <div className="w-1/3" /> */}
              <div className="w-2/3 lg:flex sm:block">
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 lg:w-max w-auto border px-8 py-4 rounded-3xl text-xs font-semibold text-role mr-2 focus:outline-none flex justify-center items-center h-6"
                  onClick={() => {
                    setOnClose(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 w-auto lg:w-max border px-8 py-4 rounded-3xl text-xs font-semibold focus:outline-none flex justify-center items-center h-6 bg-btnBg text-white"
                  onClick={handleDelete}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {openCreate && <DeviceAssetInformation handleClose={toggleOpenCreate} selectedDevice={bulkDevice[0]} />}
      {editProject && (
        <div
          className="flex justify-center items-center h-full w-full fixed top-0 left-0 devices_back"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-2/4 px-5 pt-1 relative rounded-2xl mobile_toggle">
            <img
              src="assets/img/Close.svg"
              className="absolute top-5 right-4 h-3 cursor-pointer"
              alt=""
              onClick={() => setEditProject(false)}
            />

            <p className="font-bold text-sm text-textBlue1 border-b p-4">Edit</p>

            <form className="mt-6 mb-2 mx-10 flex flex-wrap" onSubmit={handleSubmit} autoComplete="off">
              <div className="mt-5 w-2.25/5 relative">
                <div className="inputLabelText px-4 py-2 focus:outline-none ">
                  <select
                    name="role"
                    value={formData.role}
                    className="border-none w-full focus:outline-none text-sm  text-parameter border "
                    onChange={handleInputChange}
                  >
                    {roles.map((item) => (
                      <option key={item.id} value={item.id} className="fy-4">
                        {item.value}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="w-1/10" />

              <div className="mt-5 w-2.25/5 relative">
                <div className="inputLabelText px-4 py-2 focus:outline-none">
                  <select
                    name="isActive"
                    value={formData.isActive}
                    autoComplete="off"
                    className="border-none w-full focus:outline-none text-sm  text-parameter border "
                    onChange={handleInputChange}
                  >
                    <option key="true" value="Active" className="fy-4">
                      ACTIVE
                    </option>
                    <option key="false" value="InActive" className="fy-4">
                      INACTIVE
                    </option>
                  </select>
                </div>
              </div>
              <div className="mt-5 w-2.25/5 relative" />
              <div className="w-1/10" />

              {/* <div className="mt-5 w-2.25/5 relative"> */}
              <div className="mt-5 w-2.25/5 relative">
                {state2.isLoading || isLoading ? (
                  <div className="flex text-xs">
                    <img src="assets/img/loader.svg" className="w-16 right-28 mx-auto" alt="" />
                  </div>
                ) : (
                  <div className="flex text-xs">
                    <button
                      type="submit"
                      onClick={() => setEditProject(false)}
                      className="rounded-3xl border focus:outline-none w-1/2 h-10 mr-3 cursor-pointer "
                      // style={{ border: '1px solid #16406D' }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="rounded-3xl focus:outline-none w-1/2 h-10 text-white cursor-pointer "
                      style={{ background: '#16406D' }}
                    >
                      Save
                    </button>
                  </div>
                )}
              </div>
              {/* <div className="flex w-1/2 items-center  my-3.5 relative">
            <label className="block text-parameter w-1/3 text-sm" />
            {state2.isLoading || isLoading ? (
              <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto" alt="" />
            ) : (
              <input
                type="submit"
                className="rounded-lg focus:outline-none w-1/2 h-10 text-textBlue1 cursor-pointer "
                style={{ background: '#16406D33', border: '1px solid #16406D' }}
              />
            )}
          </div> */}
            </form>
          </div>
        </div>
      )}

      <div
        className="mt-10 bg-white mx-auto px-3 project_allign"
        style={{ width: '87%', height: '45vh' }}
      >
        <div className="z-50" style={{ height: '21vh', paddingBottom: '4vh' }}>
          <div
            className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto  overflow-auto"
            style={{ paddingTop: '4vh' }}
          >
            <span className="text-titleColor font-bold text-base mobile_icon9">
              Devices in {projectDetail?.projectName}{' '}
            </span>

            <div className="block lg:flex mt-1 lg:mt-0 overflow-auto ">
              <div
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs cursor-pointer font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile31 overflow-auto"
                onClick={() => {
                  handleClose(false);
                }}
              >
                Back
              </div>
              <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent px-3 py-1.5 ml-3 flex justify-between items-center rounded-3xl button_search2">
                <input
                  type="text"
                  placeholder="Search"
                  autoComplete="off"
                  className="text-textBox bg-transparent focus:outline-none button_search2"
                  value={formData.q}
                  name="q"
                  onChange={handleInputChange}
                  style={{ borderColor: '#e6e6e6' }}
                  onKeyDown={(e) => {
                    // if (e.which === 13) searchData();
                  }}
                />
                <img src="assets/img/Search.png" className="h-4 ml-2 button_search3" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="tbl mobile_view1" style={{ minWidth: '700px' }}>
          <div className="bg-white w-tableWidth m-auto mb-3">
            <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-8 py-1.5 flex w-full relative bg-primary text-white items-center">
                <div className=" text-xs font-semibold w-3/12">DEVICE</div>
                <div className=" text-xs font-semibold w-3/12">ASSET</div>
                <div className=" py-1 text-xs font-semibold w-2/12">
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.status}
                      name="status"
                      className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-7 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">STATUS</option>
                      <option value="true">ACTIVE</option>
                      <option value="false">INACTIVE</option>
                    </select>
                  </div>
                </div>
                <div className=" text-xs font-semibold w-3/12">LAST MODIFIED</div>
                <div className="text-xs font-semibold w-2/12">ACTIONS</div>
              </div>
            </div>
            {!isLoading ? (
              <div className="hideScroll" style={{ overflowY: 'scroll', height: '20vh' }}>
                <div className="w-full">
                  {projectDetail &&
                    projectDetail.DeviceInfos &&
                    projectDetail.DeviceInfos.length > 0 &&
                    projectDetail.DeviceInfos.map((item) => (
                      <div
                        className="my-2 px-8 py-1 xl:py-1.5 items-center flex
                    relative hover:border-indigo-200 focus-within:border-indigo-200"
                        style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                      >
                        {/* <input
                      type="checkbox"
                      className="absolute left-3 top-2.5"
                      checked={selectedWebhook.id === item.id}
                      onClick={() => {
                        if (selectedWebhook.id !== item?.id) {
                          selectWebhook({ id: item.id, name: item.eventType });
                        } else {
                          selectWebhook({ id: '', name: '' });
                        }
                      }}
                      // onChange={() => selectWebhook(item.id)}
                    /> */}

                        <div className="flex items-center text-role text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12  phone_font_1 font-semibold">
                          {item?.Device?.deviceType === 'BLE_TAG' ? (
                            <img src="assets/img/Bluetooth.svg" className="h-5 mr-4" alt="" />
                          ) : null}
                          {item?.Device?.deviceType === 'CATM1_TAG' ? (
                            <img src="assets/img/Cellular.svg" className="h-5 mr-4" alt="" />
                          ) : null}
                          {item?.Device?.deviceType === 'BLE_GW' ? (
                            <img src="assets/img/Gateway.svg" className="h-4 mr-4" alt="" />
                          ) : null}
                          {item?.Device?.id}
                        </div>
                        <div className="text-role flex items-center font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12">
                          {item?.TrackedUnit?.tuType === 'BOX' ? (
                            <img src="./assets/img/Box.svg" className="w-5 h-5 pr-2" />
                          ) : null}
                          {item?.TrackedUnit?.tuType === 'UNIT' ? (
                            <img src="./assets/img/Unit.svg" className="w-5 h-5 pr-2" />
                          ) : null}
                          {item?.TrackedUnit?.tuType === 'CONTAINER' ? (
                            <img src="./assets/img/Container.svg" className="w-5 h-5 pr-2" />
                          ) : null}
                          {item?.TrackedUnit?.tuType === 'PALLET' ? (
                            <img src="./assets/img/Pallet.svg" className="w-5 h-5 pr-2" />
                          ) : null}
                          {item?.TrackedUnit?.trackingId}
                        </div>
                        <div
                          className={`text-${
                            item?.isActive ? 'green-600' : 'red-600'
                          } text-left py-2 pl-4 font-semibold overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12`}
                        >
                          {item?.isActive ? 'Active' : 'Inactive'}
                        </div>
                        <div className="py-2.5 text-role text-xs w-3/12">{getTimeoffset(item?.updatedAt)}</div>
                        <div className="flex text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/6">
                          <img
                            src="assets/img/Edit2.svg"
                            className="h-3 mr-4 "
                            alt=""
                            onClick={() => {
                              setBulkDevice([item?.Device?.id]);
                              toggleOpenCreate();
                            }}
                          />
                          <img
                            src="assets/img/Delete2.svg"
                            className="h-3"
                            alt=""
                            onClick={() => {
                              setBulkDevice([item?.Device?.id]);
                              setOnClose(true);
                              setSelectedTab('Device');
                            }}
                          />
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
          </div>
        </div>
      </div>

      <div
        className="mt-10 bg-white mx-auto px-3 project_allign"
        style={{ width: '87%', height: '41vh' }}
      >
        <div className="z-50" style={{ height: '21vh', paddingBottom: '4vh' }}>
          <div
            className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto"
            style={{ paddingTop: '4vh' }}
          >
            <span className="text-titleColor font-bold text-base mobile_icon9">
              Users in {projectDetail?.projectName}{' '}
            </span>

            <div className="block lg:flex mt-1 lg:mt-0 ">
              <div
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs cursor-pointer font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile31"
                onClick={() => {
                  handleClose(false);
                }}
              >
                Back
              </div>
              <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent px-3 py-1.5 ml-3 flex justify-between items-center rounded-3xl button_search2">
                <input
                  type="text"
                  placeholder="Search"
                  autoComplete="off"
                  className="text-textBox bg-transparent focus:outline-none button_search2"
                  value={formData.q}
                  name="q"
                  onChange={handleInputChange}
                  style={{ borderColor: '#e6e6e6' }}
                  onKeyDown={(e) => {
                    // if (e.which === 13) searchData();
                  }}
                />
                <img src="assets/img/Search.png" className="h-4 ml-2 button_search3" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="tbl mobile_view1" style={{ minWidth: '700px' }}>
          <div className="bg-white w-tableWidth m-auto mb-3">
            <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-8 py-1.5 flex w-full relative bg-primary text-white items-center">
                <div className=" text-xs font-semibold w-3/12">NAME</div>
                <div className=" text-xs font-semibold w-3/12">EMAIL</div>
                <div className=" text-xs font-semibold w-3/12">CONTACT</div>
                <div className=" text-xs font-semibold w-3/12">ROLE</div>
                <div className=" text-xs font-semibold w-3/12">LAST MODIFIED</div>
                <div className="text-xs font-semibold w-2/12">ACTIONS</div>
              </div>
            </div>
            {!isLoading ? (
              <div className="hideScroll" style={{ overflowY: 'scroll', height: '20vh' }}>
                <div className="w-full">
                  {projectDetail &&
                    projectDetail.Users &&
                    projectDetail.Users.length > 0 &&
                    projectDetail.Users.map((item) => (
                      <div
                        className="my-2 px-8 py-1 xl:py-1.5 items-center flex
                    relative hover:border-indigo-200 focus-within:border-indigo-200"
                        style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                      >
                        {/* <input
                      type="checkbox"
                      className="absolute left-3 top-2.5"
                      checked={selectedWebhook.id === item.id}
                      onClick={() => {
                        if (selectedWebhook.id !== item?.id) {
                          selectWebhook({ id: item.id, name: item.eventType });
                        } else {
                          selectWebhook({ id: '', name: '' });
                        }
                      }}
                      // onChange={() => selectWebhook(item.id)}
                    /> */}

                        <div className="text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12">
                          {item?.userName}
                        </div>
                        <div className="text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12">
                          {item?.email}
                        </div>
                        <div className="text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12">
                          {item?.contact}
                        </div>
                        <div className="text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12">
                          {getRole(item?.ProjectUser?.role)}
                        </div>
                        <div className="text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12">
                          {getTimeoffset(item?.updatedAt)}
                        </div>
                        <div className="flex text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12">
                          <img
                            src="assets/img/Edit2.svg"
                            className="h-3 mr-4 "
                            alt=""
                            onClick={() => {
                              setSelectedProject({ id: item?.ProjectUser?.projectId });
                              setEditProject(true);
                              setFormData({
                                role: item?.ProjectUser?.role,
                                isActive: item?.ProjectUser?.isActive,
                                userId: item?.ProjectUser?.userId,
                              });
                            }}
                          />
                          <img
                            src="assets/img/Delete2.svg"
                            className="h-3"
                            alt=""
                            onClick={() => {
                              setSelectedProject({ id: item?.ProjectUser?.projectId, name: item?.userName });
                              setSelectedTab('User');
                              setOnClose(true);
                              setFormData({
                                userId: item?.ProjectUser?.userId,
                              });
                            }}
                          />
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectDetail;
